/**
 * AlertHistoryTab Component
 *
 * Wrapper component for the Alert History tab content.
 */

import React from 'react';

import { AlertHistoryTabContent } from '../index';
import {
  useMonitoringShared,
  useMonitoringSearch,
  useMonitoringHistoryTab,
} from '../../../contexts/MonitoringCenterContext';

/**
 * Alert History tab content wrapper
 */
export function AlertHistoryTab() {
  const shared = useMonitoringShared();
  const search = useMonitoringSearch();
  const historyTab = useMonitoringHistoryTab();

  return (
    <AlertHistoryTabContent
      filteredHistory={historyTab.filteredHistory}
      searchQuery={search.searchQuery}
      hasTestData={shared.hasTestData}
    />
  );
}
